//utama
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

//form
import Login from './login';
import Utama from './utama';

// const url_aplikasi = "http://localhost/ananta_snack_api";
// const url_file = "http://localhost/ananta_snack_file";
// const basename = "";

const url_aplikasi = "https://snack.notebookpedia.com/ananta_snack_api";
const url_file = "https://snack.notebookpedia.com/ananta_snack_file";
const basename = "";

function App() {
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route
          path="/login"
          element={
            <Login
              aplikasi={url_aplikasi}
              file={url_file}
            />
          }
        />
        <Route
          path="*"
          element={
            <Utama
              aplikasi={url_aplikasi}
              file={url_file}
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;